import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import {
  fieldCategoryParamsBuilder,
  type fieldCategoryParamsType,
} from './useCreateFieldCategory';
import messages from '../../messages';

type UpdateFieldCategoryPayloadType = fieldCategoryParamsType & {
  uuid: string;
};

const updateFieldCategory = async (
  fieldCategory: UpdateFieldCategoryPayloadType,
) => {
  const { data } = await putRequest(
    API.PUT.updateFieldCategory(fieldCategory.uuid),
    fieldCategoryParamsBuilder(fieldCategory),
  );
  return data;
};

export const useUpdateFieldCategory = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateFieldCategory,
    onSuccess: (_, { uuid }) => {
      client.invalidateQueries({ queryKey: [QUERY_KEYS.FIELD_CATEGORIES] });
      client.invalidateQueries({ queryKey: [QUERY_KEYS.FIELD_CATEGORY, uuid] });
      handleSuccess(formatMessage(messages.fieldCategorySaved), 1000);
    },
    onError: handleError,
  });
};
